var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    stroke: "#D2D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.133 27.8478L22.2643 18.6247L28.0552 12.2544C28.1862 12.1067 28.2537 11.9134 28.2431 11.7164C28.2325 11.5193 28.1446 11.3343 27.9986 11.2016C27.8525 11.0689 27.66 10.9991 27.4628 11.0073C27.2657 11.0155 27.0797 11.1012 26.9452 11.2456L21.4289 17.3131L17.633 11.3478C17.5653 11.2413 17.4718 11.1535 17.3612 11.0927C17.2506 11.0319 17.1264 11 17.0002 11H12.5002C12.3657 10.9999 12.2337 11.036 12.118 11.1045C12.0022 11.173 11.907 11.2713 11.8423 11.3892C11.7776 11.5071 11.7458 11.6402 11.7502 11.7746C11.7546 11.909 11.7951 12.0397 11.8674 12.1531L17.7361 21.3753L11.9452 27.7503C11.8776 27.823 11.825 27.9083 11.7906 28.0014C11.7562 28.0945 11.7407 28.1935 11.7448 28.2927C11.7489 28.3918 11.7727 28.4892 11.8148 28.5791C11.8568 28.669 11.9163 28.7496 11.9897 28.8164C12.0632 28.8831 12.1491 28.9346 12.2426 28.9679C12.3361 29.0012 12.4353 29.0156 12.5344 29.0103C12.6335 29.0049 12.7306 28.98 12.82 28.9369C12.9094 28.8937 12.9893 28.8333 13.0552 28.7591L18.5714 22.6916L22.3674 28.6569C22.4356 28.7625 22.5293 28.8494 22.6399 28.9093C22.7505 28.9693 22.8744 29.0005 23.0002 29H27.5002C27.6345 29 27.7664 28.9638 27.882 28.8954C27.9976 28.827 28.0927 28.7288 28.1573 28.611C28.222 28.4933 28.2539 28.3604 28.2496 28.2261C28.2453 28.0918 28.205 27.9612 28.133 27.8478ZM23.4118 27.5L13.8661 12.5H16.5849L26.1343 27.5H23.4118Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial4);
export default __webpack_public_path__ + "static/media/social4.acb6825699cdcc601b9b751b6e2b7308.svg";
export { ForwardRef as ReactComponent };